import React, { useEffect, useState } from "react";
import { Loader2, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function ContratPagesPicker({ dossierId, item, onSaved }) {
  const [data, setData] = useState(null);
  const [sel, setSel] = useState([]);
  useEffect(() => {
    let alive = true;
    setData(null);
    api.get(`/dossiers/${dossierId}/dossier-pose/contrat`).then((r) => { if (alive) { setData(r.data); setSel(r.data.selected); } }).catch(() => alive && setData({ thumbs: [], error: true }));
    return () => { alive = false; };
  }, [dossierId, item.chosen]);
  const save = (pages) => {
    setSel(pages || data.rule_pages);
    api.put(`/dossiers/${dossierId}/dossier-pose`, { contrat_pages: pages }).then((r) => { onSaved(r.data); setData((d) => ({ ...d, custom: pages !== null })); }).catch(() => toast.error("Enregistrement impossible"));
  };
  const flip = (p) => save(sel.includes(p) ? sel.filter((x) => x !== p) : [...sel, p].sort((a, b) => a - b));
  if (!data) return <div className="py-6 flex justify-center"><Loader2 className="w-4 h-4 animate-spin" /></div>;
  if (data.error) return <div className="text-xs text-red-700" data-testid="contrat-error">Impossible de lire le contrat de financement.</div>;
  return (
    <div className="mt-2 p-3 rounded-lg border border-norea-border bg-norea-bg/50" data-testid="contrat-pages-picker">
      <div className="flex items-center justify-between mb-2 text-xs">
        <span className="font-semibold">Pages du contrat à garder · <span data-testid="contrat-selected-count">{sel.length}</span>/{data.page_count}</span>
        <span className="text-norea-textMuted">
          Règle du financeur : {data.rule || "tout le contrat"}
          {data.custom && <button onClick={() => save(null)} className="ml-2 inline-flex items-center gap-1 text-norea-primary hover:underline" data-testid="contrat-reset"><RotateCcw className="w-3 h-3" />Revenir à la règle</button>}
        </span>
      </div>
      {sel.length === 0 && <div className="text-[11px] text-amber-700 mb-2" data-testid="contrat-none-warning">Aucune page cochée : le contrat ne sera pas ajouté au dossier de pose.</div>}
      <div className="grid grid-cols-4 sm:grid-cols-6 gap-2 max-h-72 overflow-y-auto">
        {data.thumbs.map((src, i) => {
          const p = i + 1, on = sel.includes(p);
          return (
            <button key={p} onClick={() => flip(p)} className={`relative rounded border-2 overflow-hidden transition-[border-color,opacity] ${on ? "border-norea-primary" : "border-transparent opacity-40"}`} data-testid={`contrat-page-${p}`}>
              <img src={src} alt={`Page ${p}`} className="w-full block bg-white" />
              <span className="absolute top-1 left-1 text-[10px] bg-white/90 rounded px-1 flex items-center gap-1"><input type="checkbox" readOnly checked={on} className="w-3 h-3" />{p}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
